export default function getBaseUrl() {
  if (process.env.FUNDAMENTEI_ENV === "development") {
    return "http://localhost:25258";
  }

  if (process.env.FUNDAMENTEI_ENV === "qa") {
    return "https://qa.fundamentei.com";
  }

  if (process.env.FUNDAMENTEI_ENV === "production") {
    return "https://fundamentei.com";
  }

  throw new Error("Couldn't figure out the base URL. Missing environment variable `FUNDAMENTEI_ENV`");
}
